module.exports = __webpack_public_path__ + "static/media/Simple-Line-Icons.d2285965.ttf";